var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-slide-x-reverse-transition',[_vm._t("default",function(){return [_c('div',{staticClass:"subheading grey--text"},[_vm._v("Нет данных для отображения")])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }